import { render } from "./DynamicContent.vue?vue&type=template&id=62bf2f91&scoped=true"
import script from "./DynamicContent.vue?vue&type=script&lang=js"
export * from "./DynamicContent.vue?vue&type=script&lang=js"

import "./DynamicContent.vue?vue&type=style&index=0&id=62bf2f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bf2f91"]])

export default __exports__